import { useQuery, useQueryClient } from '@tanstack/react-query';
import { type Agent, panic } from '@ev-tech/search-modules-api';

import { getAgentProfileQueryKey } from './queryKeys';
import { useAppContext } from '../useAppContext';
import { useSearchStore } from '../stores/search/useSearchStore';

export const useAgentProfile = () => {
  const { api } = useAppContext();
  const promotedBy = useSearchStore((state) => state.promotedBy);
  const agentId = useSearchStore((state) => state.agentId);
  const queryClient = useQueryClient();

  const targetAgentId = promotedBy ?? agentId;

  return useQuery({
    queryKey: getAgentProfileQueryKey({ agentId: targetAgentId }),
    queryFn: async () => {
      const result = await api.getAgentById(targetAgentId ?? panic('Agent ID is missing'));
      if (result.status === 'error') throw result.error;
      return result.data;
    },
    enabled: Boolean(targetAgentId),
    placeholderData: (previousData) => {
      if (previousData) return previousData;

      return queryClient.getQueryData<Agent>(getAgentProfileQueryKey({ agentId: targetAgentId }));
    },
  });
};
